package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/monsters-inc". Pulls the REAL cached analysis from PROD. */
@Page("/isitsafe/monsters-inc")
@Composable
fun MonstersIncReviewPage() {
    PublicReviewPage(
        slug = "monsters-inc",
        blurb = "Is Monsters, Inc. suitable for Muslim children? Fitrah Filter breaks down the content against Islamic values so you can decide with confidence.",
    )
}
